/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ServiceCategoryRenameDto } from '../../models/service-category-rename-dto';
import { ServiceItem } from '../../models/service-item';

export interface ServiceControllerRenameCategory$Params {
  id: number;
      body: ServiceCategoryRenameDto
}

export function serviceControllerRenameCategory(http: HttpClient, rootUrl: string, params: ServiceControllerRenameCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceItem;
}>> {
  const rb = new RequestBuilder(rootUrl, serviceControllerRenameCategory.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ServiceItem;
      }>;
    })
  );
}

serviceControllerRenameCategory.PATH = '/service/category/{id}';
